import { __ } from 'first-intl';
import React, { ReactElement } from 'react';
import { Config } from '../../../config';
import { PlainMessageId } from '../../../messages';
import { WsBonusShopCustomerData } from '../../../ws/result/WsBonusShopCustomerData';
import { WsBonusShopOrder } from '../../../ws/result/WsBonusShopOrder';
import { WsSalutation } from '../../../ws/result/WsSalutation';
import { BonusPoints } from '../../BonusPoints';
import { ReducedProduct } from '../../../ws/result/ReducedProduct';

type _OrderConfirmationPrintLayoutType = {
    getCustomerName: (customerData: WsBonusShopCustomerData) => string;
    renderPrintRow: (labelId: PlainMessageId, value?: string | number) => ReactElement;
    renderArticleNumber: ({ attributes: { ean }, articleId }: ReducedProduct) => ReactElement;
};

const _OrderConfirmationPrintLayout: _OrderConfirmationPrintLayoutType = {} as any;

_OrderConfirmationPrintLayout.getCustomerName = (customerData: WsBonusShopCustomerData): string => {
    if (customerData.salutation === WsSalutation.COMPANY) {
        return customerData.lastName;
    } else {
        const firstName = customerData.firstName;
        return (firstName ? firstName + ' ' : '') + customerData.lastName;
    }
};

_OrderConfirmationPrintLayout.renderPrintRow = (labelId: PlainMessageId, value?: string | number): ReactElement => (
    <div className="row">
        <span className="col-xs-4">{__(labelId)}</span>
        <span className="col-xs-8">{value}</span>
    </div>
);

_OrderConfirmationPrintLayout.renderArticleNumber = ({ attributes, articleId }: ReducedProduct) => {
    if (attributes?.ean) {
        return _OrderConfirmationPrintLayout.renderPrintRow('page.Confirmation.print.ean', attributes.ean);
    } else {
        return _OrderConfirmationPrintLayout.renderPrintRow('page.Confirmation.print.id', articleId);
    }
};

export type OrderConfirmationPrintLayoutProps = { lastOrder: WsBonusShopOrder; points: BonusPoints };

export const OrderConfirmationPrintLayout: React.FC<OrderConfirmationPrintLayoutProps> = ({
    lastOrder: { article, orderDate, orderToken },
    points,
}) => (
    <div className="visible-print">
        <header className="page-header">
            <h1>
                {__(process.env.IS_HUDU ? 'page.Confirmation.print.title.hudu' : 'page.Confirmation.print.title.eBook')}
            </h1>
        </header>

        <div className="orderBonus-confirm">
            {_OrderConfirmationPrintLayout.renderPrintRow('page.Confirmation.print.date', orderDate)}
            {_OrderConfirmationPrintLayout.renderPrintRow('page.Confirmation.print.number', orderToken)}
            {_OrderConfirmationPrintLayout.renderPrintRow(
                'page.Confirmation.print.card',
                Config.get().customerData.loyaltyCardNumbers.join(', ')
            )}
            {_OrderConfirmationPrintLayout.renderPrintRow(
                'page.Confirmation.print.name',
                _OrderConfirmationPrintLayout.getCustomerName(Config.get().customerData)
            )}
            {_OrderConfirmationPrintLayout.renderPrintRow('page.Confirmation.print.article', article.attributes.title)}
            {_OrderConfirmationPrintLayout.renderArticleNumber(article)}
            {_OrderConfirmationPrintLayout.renderPrintRow('page.Confirmation.print.cost', article.price.bonusCost)}
            {_OrderConfirmationPrintLayout.renderPrintRow('page.Confirmation.print.totalpoints', points.getFormatted())}
        </div>
    </div>
);
